import { computed } from "vue";
import { useAuthStore } from "../AuthStore/useAuthStore";

export function useNotificationsV2() {
  const { userPreferences } = useAuthStore();

  const isV2Enabled = computed(() =>
    userPreferences.value?.notificationsV2Enabled ?? false,
  );

  return { isV2Enabled };
}
